<template>
    <div class="loginBg">
        <div class="loginBox">
            <h3 class="title">请登录</h3>
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
                <el-form-item prop="username">
                    <el-input
                    v-model="loginForm.username"
                    type="text"
                    auto-complete="off"
                    placeholder="账号"
                    >
                        <i slot="prefix"> <img src="@/assets/icon/username.png" alt=""></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                    v-model="loginForm.password"
                    type="password"
                    auto-complete="off"
                    placeholder="密码"
                    @keyup.enter.native="handleLogin"
                    >
                        <i slot="prefix"> <img src="@/assets/icon/password.png"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input
                    v-model="loginForm.code"
                    placeholder="验证码"
                    >
                        <i slot="prefix"> <img src="@/assets/icon/code.png"></i>
                        <div slot="suffix">
                            <!-- 验证码组件 -->
                            <div class="login-code" @click="refreshCode">
                                <s-identify :identifyCode="identifyCode" :contentWidth="80" :contentHeight="30"></s-identify>
                            </div>
                        </div>
                    </el-input>

                </el-form-item>
                <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住用户名</el-checkbox>
                <el-form-item style="width:100%;">
                    <el-button
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    round
                    @click.native.prevent="handleLogin"
                    >
                    <span v-if="!loading">登 录</span>
                    <span v-else>登 录 中...</span>
                    </el-button>
                    <div style="text-align:center">
                        <router-link class="link-type" :to="'/registration'">注册</router-link>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import SIdentify from '@/components/SIdentify'
import api from '@/util/request'
import md5 from 'js-md5'
export default {
    components:{
        SIdentify
    },
    data() {
        const validateCode = (rule, value, callback) => {
            if (this.identifyCode !== value) {
                this.refreshCode()
                callback(new Error('验证码错误'))
            } else {
                callback()
            }
        }
        return {
            loginForm:{
                username: localStorage.getItem('username'),
                password: null ,
                type: 1
            },
            loading: false,
            loginRules: {
                username: [
                { required: true, trigger: "blur", message: "请输入您的账号" }
                ],
                password: [
                { required: true, trigger: "blur", message: "请输入您的密码" }
                ],
                code: [
                    { required: true, trigger: "blur", message: "请输入验证码" },
                    { validator: validateCode, trigger: 'blur' }
                ]
            },
            // 验证码
            identifyCode: ""
        }
    },
    mounted(){
        // 验证码
        this.refreshCode();
    },
    methods: {
        //验证码
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            // 获取随机数
            let codes = '0123456789';
            for (let i = 0; i < 4; i++) {
                this.identifyCode += codes[this.randomNum(0, codes.length)];
            }
        },
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (!valid) return false;
                this.loginForm.password = md5(this.loginForm.password)
                this.loading = true
                if(this.loginForm.rememberMe){
                  localStorage.setItem('username',this.loginForm.username)
                }else{
                  localStorage.clear()
                }
                api.post('/account/login',this.loginForm).then(res=>{
                    console.log(res)
                    this.loading = false
                    if(res.status===200){
                        localStorage.setItem('user',JSON.stringify(res.data))
                        localStorage.setItem('token',res.data.token)
                        this.$router.push({path:'/order'})
                    }else{
                        this.$message.error(res.msg);
                    }

                })
                })
        }

    }
}
</script>

<style lang="scss" scoped>
.loginBg{
    background: url('../../assets/home/loginBg.png') no-repeat;
    background-size: cover;
    height: 800px;
    display: flex;
    align-items: center;
    .title{
        margin-bottom: 30px;
        text-align: center;
    }
    .loginBox{
        width: 400px;
        margin: 0 auto;
        background: #fff;
        padding: 60px 60px 30px;
        border-radius: 8px;
    }
}
.login-code{
    margin-top: 5px;
    margin-right: 10px;
}
</style>
